import React from 'react'
import { Link } from 'react-router'
import RaisedButton from 'material-ui/RaisedButton'

const Section = ({body, buttonText, description, extraClassNames, path, title}) => {
    const SectionBody = body;

    return (
      <section className={`section-container ${extraClassNames}`}>
        <h1 className="section-header">
          {title}
        </h1>
        <div className="section-description">
          <p>{description}</p>
        </div>
        <SectionBody className="section-body"/>
        <div className="learn-more">
          <Link to={path}>
          <RaisedButton
            style={{ marginTop: '10px', marginBottom: '5px', minWidth: '200px'}}
            label={buttonText}
            className="mm-button"
          />
          </Link>
        </div>
      </section>
    );
}


export default Section



// WEBPACK FOOTER //
// ./src/components/Home/Section.js